<template>
    <div v-if="totalPages > 1" class="card-footer px-3 border-0 d-flex flex-column flex-lg-row align-items-center justify-content-between">
        <nav aria-label="page navigation">
            <ul class="pagination mb-0">
                <li class="page-item" :class="{ 'disabled': page === 1 }">
                    <button class="page-link" @click="change(page - 1)">Anterior</button>
                </li>
                <li v-for="num in paginationNumbers" :key="num" class="page-item" :class="{ 'active': num === page }">
                    <button v-if="num" class="page-link" @click="change(num)">{{ num }}</button>
                    <button v-else class="page-link" disabled>...</button>
                </li>
                <li class="page-item" :class="{ 'disabled': page === totalPages }">
                    <button class="page-link" @click="change(page + 1)">Próximo</button>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
export default {
    inheritAttrs: false,
    props: {
        change: {
            type: Function,
            required: true
        },
        totalRecords: {
            type: Number,
            default: 0,
            required: true
        },
        recordsPerPage: {
            type: Number,
            default: 0,
            required: true
        },
        page: {
            type: Number,
            default: 0,
            required: true
        },
    },
    computed: {
        totalPages() {
            return Math.ceil(this.totalRecords / this.recordsPerPage);
        },
        paginationNumbers() {
            let numbers = [];
            let startPage, endPage;

            // Casos especiais para a primeira e última página e quando há menos de 10 páginas
            if (this.totalPages <= 9) {
                startPage = 1;
                endPage = this.totalPages;
            } else if (this.page <= 5) {
                startPage = 1;
                endPage = 6;
            } else if (this.page >= this.totalPages - 4) {
                startPage = this.totalPages - 6;
                endPage = this.totalPages;
            } else {
                startPage = this.page - 2;
                endPage = this.page + 2;
            }

            // Adiciona páginas anteriores se necessário
            if (startPage > 1) {
                numbers.push(1, null);
                startPage++;
            }

            // Adiciona páginas dentro do intervalo
            for (let i = startPage; i <= endPage; i++) {
                numbers.push(i);
            }

            // Adiciona páginas seguintes se necessário
            if (endPage < this.totalPages) {
                if (endPage < this.totalPages - 1) {
                    numbers.push(null);
                }
                numbers.push(this.totalPages);
            }

            return numbers;
        }
    },





}
</script>

<style scoped>

</style>
